var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root-default-layout"},[_c('header-partial'),(_vm.notFound)?_c('page-not-found'):_c('router-view'),_c('footer-partial')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }